module.exports = __webpack_public_path__ + "img/Edit Patient - Green.30e2d404.png";